import { render, staticRenderFns } from "./ConfigureImage.vue?vue&type=template&id=cd8efce4&scoped=true&"
import script from "./ConfigureImage.vue?vue&type=script&lang=js&"
export * from "./ConfigureImage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureImage.vue?vue&type=style&index=0&id=cd8efce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8efce4",
  null
  
)

export default component.exports